<template>
  <section class="notFoundCnt" v-on:click="sectionClicked">
    <Header :class="{scrolled: isScrolled}" ref="header"/>
    <div class="notFound">
      <img src="../assets/not-found.png">
      <h4>404</h4>
      <h2>Halaman tidak ditemukan</h2>
      <p>We can't find the page you looking for</p>
    </div>
  </section>
</template>

<script>
import Header from '@/components/Header.vue';

export default {
  name: 'notFound',
  components: { Header },
  data() {
    return {
      isScrolled: false,
    };
  },
  methods: {
    sectionClicked() {
      if (this.$refs.header) this.$refs.header.sectionClicked();
    },
    scrolled() {
      this.isScrolled = window.scrollY > 30;
    },
  },
  created() {
    document.addEventListener('scroll', this.scrolled);
  },
  destroyed() {
    document.removeEventListener('scroll', this.scrolled);
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.notFoundCnt{
  position: relative;
  height: 100vh;
  .notFound{
    position: absolute;
    left: 40px; right: 40px;
    top: 50%; transform: translateY(-50%);
    margin-top: 20px;
    text-align: center;
    color: #767676;
    img{
      height: auto;
      width: 100%;
      max-width: 500px;
      margin-bottom: 40px;
    }
    h2{
      margin: 0 0 4px;
      font-size: 30px;
      line-height: 1;
    }
    h4{
      margin: 0;
      font-size: 50px;
      line-height: 1;
    }
    p{
      margin: 0;
    }
  }
}
</style>
